export function formatBigNum(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function valueFormat(data, type) {
  switch (true) {
    case data === "-":
      return "-";
    case type.includes("rate") || type === "fb_ad_network_ctr":
      return numberFormat(parseFloat(data) * 100) + "%";
    case type === "fb_ad_network_revenue" || type === "fb_ad_network_cpm":
      return `$${numberFormat(data)}`;
    default:
      return formatBigNum(numberFormat(data));
  }
}

export function numberFormat(data) {
  const floatData = parseFloat(data);
  if (Number.isInteger(floatData)) {
    return data;
  } else {
    return floatData.toFixed(2);
  }
}
